<div class="task-complete-container">
  <img [src]="completedTasks.taskCompletionImage" class="completion-image" alt="Picking Complete" />
  <div class="message">
    <h2>{{ completedTasks.taskCompletionTitle }}</h2>
    <p>
      {{ completedTasks.taskCompletionMessage }}
    </p>
  </div>
  <p *ngIf="showReDirecttext" class="mt-4" style="color: #54BB70; font-size: 16px; font-weight: 400;">Redirecting to worklist .... 3 seconds</p>
</div>
